const CART_API_TIMEOUT = 10000;

const cartTimeoutPromise = (ms) =>
  new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), ms));

const CartAPI = {
  routes: {
    add: 'cart/add.js',
    change: 'cart/change.js',
    update: 'cart/update.js',
    get: 'cart.js',
    clear: 'cart/clear.js',
  },

  getRoot() {
    return window.Shopify?.routes?.root || '/';
  },

  async add(formData, sections = []) {
    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch(`${this.getRoot()}${this.routes.add}`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  },

  async addItems(items, sections = []) {
    const body = { items };

    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${this.getRoot()}${this.routes.add}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  },

  async change(identifier, quantity, sections = [], signal) {
    if (!identifier && identifier !== 0) throw new Error('Cart change: identifier is required');

    const body = { quantity };
    if (typeof identifier === 'string') {
      body.id = identifier;
    } else {
      body.line = identifier;
    }

    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${this.getRoot()}${this.routes.change}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal,
    });

    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  },

  async update(body, sections = [], signal) {
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${this.getRoot()}${this.routes.update}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal,
    });

    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  },

  async get() {
    const response = await fetch(`${this.getRoot()}${this.routes.get}`);
    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  },

  async clear(sections = []) {
    const body = {};

    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${this.getRoot()}${this.routes.clear}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  },
};

const updateCartCount = (count) => {
  const safeCount = Number(count) || 0;
  if (typeof CartStore !== 'undefined') {
    CartStore.cartItemCount = safeCount;
  }
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = safeCount > 0 ? String(safeCount) : '';
    el.dataset.cartCount = safeCount;
    el.classList.toggle('hidden', safeCount === 0);
  });
};
